var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tabs',{attrs:{"background-color":"primary","dark":""}},_vm._l((_vm.routes),function(route){return _c('v-tab',{key:route.name,attrs:{"to":{ name: route.name }}},[_vm._v(" "+_vm._s(route.meta.label)+" ")])}),1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }